module.exports = __webpack_public_path__ + "img/pessoas-cooperando.jpg";